import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function AdminLogin({ password, onPasswordChange, onSubmit }) {
  return (
    <main data-testid="admin-login-page" className="min-h-[70vh] flex items-center justify-center py-24 px-4">
      <div className="w-full max-w-md bg-card border border-border rounded-2xl p-8 shadow-sm">
        <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-secondary text-secondary-foreground mb-4">
          <Lock className="h-5 w-5" />
        </div>
        <h1 className="font-display text-3xl text-foreground">Admin</h1>
        <p className="font-body text-foreground/70 mt-2">Quiet room. Password please.</p>
        <form onSubmit={onSubmit} data-testid="admin-login-form" className="mt-6 space-y-4">
          <div>
            <Label className="font-ui text-xs uppercase tracking-[0.2em] text-muted-foreground">Password</Label>
            <Input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => onPasswordChange(e.target.value)}
              className="mt-2 font-ui h-12 bg-background"
              autoFocus
            />
          </div>
          <Button type="submit" data-testid="admin-login-submit" className="w-full h-12 rounded-full font-ui bg-primary text-primary-foreground hover:bg-primary/90">
            Enter
          </Button>
        </form>
      </div>
    </main>
  );
}
